import React from "react";

// Modules
import parse from 'html-react-parser';

import { Typography } from "@mui/material";

import { bodyToText } from "../utils/helpers";

const regex = /(<([^>]+)>)/gi;

export default function PostExcerpt(props) {
  let defaultStyle = 'excerpt text-break';
  let style = props.className ? `${props.className} ${defaultStyle}` : defaultStyle;

  let EXCERPT_MAX_LENGTH;
  if (props.maxLength) {
    EXCERPT_MAX_LENGTH = props.maxLength;
  }

  // Shared by both clients' screens. Callers pass `summary || body`, and on
  // the companyapp entity path a `body` is EditorJS JSON, not a string —
  // .replace() below would throw on it. equans' v2 node bodies are already
  // strings and pass through bodyToText untouched.
  let excerpt = bodyToText(props.body);

  if (!excerpt) {
    return null;
  }

  excerpt = excerpt.replace(regex, "").trimEnd();

  if (excerpt.length > EXCERPT_MAX_LENGTH) {
    excerpt = excerpt.substring(0, EXCERPT_MAX_LENGTH);
    excerpt = excerpt.substring(0, excerpt.lastIndexOf(" "));
    excerpt += "...";
  }

  return (
    // <div
    //   dangerouslySetInnerHTML={{ __html: parse(excerpt) }}
    //   className={style}
    // />
    <Typography
      className={style}
      owner={props.owner}
      variant={props.variant}
      color={props.excerptColor}
      weight={props.weight}
      lh={props.lh}
    >
      {parse(excerpt)}
    </Typography>
  );
}
